import {useMutation} from '@apollo/react-hooks';

import type {
    UpdateForm as UpdateFormMutation,
    UpdateFormVariables as UpdateFormMutationVariables,
    FormUpdateInput,
} from 'nutshell-graphql-types';

import WF_FORM_FRAGMENT from '../graphql/fragments/wf-form-fragment.graphql';
import WF_FORM_UPDATE from '../graphql/mutations/update-wf-form.graphql';

export function useWfFormUpdate(): (arg1: FormUpdateInput) => Promise<any> {
    const [updateWfForm] = useMutation<UpdateFormMutation, UpdateFormMutationVariables>(
        WF_FORM_UPDATE
    );

    return (input: FormUpdateInput) => {
        return updateWfForm({
            variables: {
                input,
            },
            update: (proxy, mutationResults) => {
                // Read the data from our cache for this fragment
                const formFragment = proxy.readFragment({
                    id: input.form.id,
                    fragmentName: 'WfFormFragment',
                    fragment: WF_FORM_FRAGMENT,
                });

                if (formFragment) {
                    const updatedForm =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.formUpdate &&
                        mutationResults.data.formUpdate.form;

                    if (!updatedForm) return;

                    proxy.writeFragment({
                        id: input.form.id,
                        fragmentName: 'WfFormFragment',
                        fragment: WF_FORM_FRAGMENT,
                        data: updatedForm,
                    });
                }
            },
        });
    };
}
